import { MouseEventHandler, ReactNode } from 'react';

import { textButton } from './styles.css';

export interface HeaderTextButtonProps {
  children: ReactNode;
  /**
   * @default "default"
   */
  type?: 'default' | 'primary';
  icon?: ReactNode;
  /**
   * @default "button"
   */
  htmlType?: 'submit' | 'reset' | 'button';
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const HeaderTextButton = (props: HeaderTextButtonProps) => {
  const { children, type = 'default', icon, htmlType = 'button', onClick } = props;
  return (
    <button
      type={htmlType}
      className={textButton({
        type,
      })}
      onClick={onClick}
    >
      {icon}
      {children}
    </button>
  );
};
